import NProgress from 'nprogress'; // progress bar
import { getStore } from '@/store';
import router from './index';
import authRouter from './modules/auth';
import 'nprogress/nprogress.css'; // progress bar style

NProgress.configure({ showSpinner: false }); // NProgress Configuration

/**
 * Generate white list
 */
const whiteList = (Array.from(authRouter, (route) => route.name)
  .concat(Array.from(authRouter, (route) => route.alias)))
  .filter((route) => route); // remove undefined element

/**
 * Check user has permission for this routes.
 * 'admin' permission passed directly.
 * @param {Array} groups
 * @param {Array} permissiongroups
 */
function hasPermission(groups, permissiongroups) {
  if (!permissiongroups || (permissiongroups && !permissiongroups.length)) {
    return true;
  }
  return groups.some((role) => permissiongroups.includes(role));
}

// we are not using async to wait for updateUser, so there will be a flash of page where the user is assumed not to be logged in. If we use a flag
// return () => Hub.remove('auth', updateUser); // cleanup

let authLoopGuard = 0;
/** Counts the number of times auth has been unsuccessfully checked */
function guardLoop() {
  authLoopGuard += 1;
  if (authLoopGuard >= 2) {
    authLoopGuard = 0;
    return true;
  }
  return false;
}

router.beforeEach(async (to, from, next) => {
  NProgress.start();

  // let logMsg = '[router.beforeEach]';

  if (whiteList.includes(to.name)) {
    next();
    NProgress.done();
    return;
  }

  try {
    // 1. determine if the user is logged in
    const store = getStore();

    const userCheck = (user, noReload) => {
      authLoopGuard = 0;
      // user is logged in, check rights
      if (hasPermission(user.groups, to.meta.groups)) {
        // logMsg += `\t[Permission=${to.meta.groups}]\t[next]`;
        if (noReload) {
          next();
        } else {
          // dynamic route hack
          next({ ...to, replace: true });
        }
      } else {
        // logMsg += `\t[!Permission=${to.meta.groups}]\t[next /401]`;
        next({ path: '/401', replace: true, query: { noGoBack: true } });
      }
    };

    if (!store.getters.user) {
      store.dispatch('GetUserInfo')
        .then(userCheck, () => {
          if (guardLoop()) {
            next('/401');
          } else {
            next('/login');
          }
        });
    } else {
      const { user } = store.getters;
      userCheck(user, true);
    }
  } catch (err) {
    console.log(err);
    next('/login');
  }

  // console.log(logMsg, to.path);
  NProgress.done();
});

router.afterEach(async () => {
  NProgress.done();
});
